import WebAPI from './api-calls';

const webApi = new WebAPI();

export async function fetchWasteTransactions() {
  const endpoint = '/api/multiutility/waste-transactions';

  const response = await webApi.getFromWebApiWithAccessTokenAsync(endpoint);

  return response.data;
}